import React from 'react'
import styled from 'styled-components'

import GlobalWrapper from 'components/global-wrapper'
import media from 'utils/media-queries'

import Header from 'components/article/header'
import ContentWrapper from 'components/article/contentwrapper'
import Footer from 'components/footer'
import FullSizeImage from 'components/article/fullsizeimage'

import gtocResultGif from 'img/articles/gtocx/gtocxresult.gif'

const Section = styled.section`
  margin: 64px 0;
  ${media.sm`
    margin: 0;
  `}
`

const EmbedContainer = styled.div`
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  width: 100%;
  height: auto;
  margin-top: 32px;
  margin-bottom: 32px;
  @media (min-width: 1000px) {
    width: 1000px;
    height: 562px;
    padding-bottom: 0px;
    margin-left: auto;
    margin-right: auto;
  }
`

const Video = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`

const ImageGrid = styled.div`
  background: #f2f2f2;
  max-width: 100%;
  padding: 40px;
  margin: 32px 0;
  text-align: center;
  ${media.lg`
    padding: 32px;
    margin: 0 0 24px 0;
  `}
  ${media.md`
    margin: 0;
    margin: 0 0 16px 0;
  `}
  ${media.sm`
    padding: 16px;
  `}
`

const Img = styled.img`
  max-width: calc(100% - 96px);
  max-height: 300px;
  margin: 8px;
  display: inline-block;
  ${media.xl`
    max-height: 240px;
  `}
  ${media.lg`
    max-height: 200px;
  `}
  ${media.md`
    max-height: 120px;
    margin: 4px;
  `}
  ${media.sm`
    max-height: 80px;
    margin: 2px;
  `}
`

const GtocX = () => {
  return (
    <GlobalWrapper>
      <Header title="GTOC-X: Karmarkar’s Gang " />
      {/* <CoverImage src={CoverSrc} focusX={'35%'} focusY={'50%'} /> */}
      <Section>
        <ContentWrapper>
          <h3>What is GTOC ?</h3>
          <p>
            The Global Trajectory Optimization Competition is an event taking
            place every one-two years over roughly one month during which the 
            best aerospace engineers and mathematicians world wide challenge
            themselves to solve a “nearly-impossible” problem of interplanetary 
            trajectory design. 
          </p>
        </ContentWrapper>
        <ContentWrapper>
          <h3>10th Global Trajectory Optimization Competition</h3>
          <p>
            The 10th edition of GTOC was organised by the Jet Propulsion Laboratory 
            Outer Planets Mission Analysis Group.

          </p>
          <p>
            Official competition web site can be found <a target='_blank' href={"https://gtocx.jpl.nasa.gov"}>here</a>. In a nutshell, theme for
            10th edition was “settler of the galaxy”. Three types of interstellar generational
            vessels are imagined to be sent around the Milky Way to spread the human race 
            throughout the galaxy in a quest 90 Myr long.
          </p>
        </ContentWrapper>
        <ContentWrapper>
          <h3>Abstract of our approach</h3>
          <p>
            An exploratory analysis was carried on the stars at first to understand the 
            variation of star systems with position, polar angle and time. This analysis 
            provided us with the insight to explore the galactic space. With three types of 
            interstellar vessels each of them were formulated with different strategy to 
            explore. 
    
            The fast ships being capable of providing maximum &Delta;V they are 
            used to explore the edges of the galaxy. While mother ships having 
            up to three &Delta;Vs they are used to form the backbone of settler 
            ships in a spacially symmetrically formation. Finally, the settler ships are
            being actually responsible for formation of chain of settled stars.

          </p>
        </ContentWrapper>
        <ContentWrapper>
          <h3>Results</h3>
          <p>
            Nearly 3000 stars are being settled at the end of 13 generations.
            The merit function 𝐽 reaches to about 150.
          </p>
        </ContentWrapper>
        <FullSizeImage src={gtocResultGif} />
        <ContentWrapper>
          <p>
            To understand our approach in detail : <a href={"https://arxiv.org/abs/2011.00226"}>https://arxiv.org/abs/2011.00226</a>
            <br/>Find code on github at : <a href={"https://github.com/visheshv/settlers_of_galaxy"}>Settlers of Galaxy</a>
          </p>
        </ContentWrapper>
      </Section>
      <Footer />
    </GlobalWrapper>
  )
}

export default GtocX
